<template>
    <text-dialog fullscreen :value.sync="dialog" @close="cancel">
        <v-tooltip top slot="activator">
            <v-btn class="pl-2" outline :disabled="disabled" block slot="activator">
                <v-icon>group_add</v-icon>&nbsp;{{ $t('create_starter') }}</v-btn>
            <span v-t="'create_starter_for_event'"></span>
        </v-tooltip>
        <span slot="content">
            <starter-template v-if="dialog" @cancel="cancel" @submit="submit"></starter-template>
        </span>
    </text-dialog>
</template>

<script>
    import StarterTemplate from "../user/StarterTemplate";
    import TextDialog from '../../components/dialogs/TextDialog';

    export default {
        components: {
            StarterTemplate,
            TextDialog
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            event_id: {
                type: Number,
                default: null
            },
            starter: {
                type: Object,
                default: null
            }
        },
        watch: {
            value() {
                this.dialog = this.value;
            },
            dialog() {
                this.$emit('update:value', this.dialog);
            }
        },
        data() {
            return {
                dialog: false
            }
        },
        methods: {
            submit(starter) {
                this.dialog = false;
                this.$emit('submit', starter);
            },
            cancel() {
                this.dialog = false;
                this.$emit('cancel');
            }
        }
    }
</script>